import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchEmployerCandidateJobApplyExportbyJobUuid } from "./employerCandidateJobApplyListByJobUuidExportAPI";

const initialState = {
    response: [], // Changed from data to response
    loading: false,
    error: null,
    status: 'idle',
    currentJobUuid: null,
    lastUpdated: null
};

export const fetchEmployerCandidateJobApplyExportbyJobUuidAsync = createAsyncThunk(
    "employerCandidateJobApplyExportByJobUuid/fetch",
    async (job_uuid, { rejectWithValue }) => {
        try {
            const result = await fetchEmployerCandidateJobApplyExportbyJobUuid(job_uuid);

            if (!result.success) {
                throw new Error(result.message || "Failed to fetch candidates");
            }

            return {
                job_uuid,
                response: result.response, // Changed from candidates to response
                total: result.total,
                timestamp: new Date().toISOString()
            };

        } catch (error) {
            return rejectWithValue({
                message: error.message,
                job_uuid,
                code: error.code || "FETCH_ERROR"
            });
        }
    }
);

const employerCandidateJobApplyExportByJobUuidSlice = createSlice({
    name: "employerCandidateJobApplyExportByJobUuid",
    initialState,
    reducers: {
        resetState: () => initialState,
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerCandidateJobApplyExportbyJobUuidAsync.pending, (state) => {
                state.loading = true;
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchEmployerCandidateJobApplyExportbyJobUuidAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.status = 'succeeded';
                state.response = action.payload.response; // Changed from data to response
                state.currentJobUuid = action.payload.job_uuid;
                state.lastUpdated = action.payload.timestamp;
                state.error = null;
            })
            .addCase(fetchEmployerCandidateJobApplyExportbyJobUuidAsync.rejected, (state, action) => {
                state.loading = false;
                state.status = 'failed';
                state.error = {
                    message: action.payload?.message || "Failed to fetch candidates",
                    code: action.payload?.code,
                    jobUuid: action.payload?.job_uuid
                };
                state.response = [];
            });
    }
});

// Updated selectors
export const selectJobApplicants = (state) => state.employerCandidateJobApplyExportByJobUuid.response;
export const selectApplicantsLoading = (state) => state.employerCandidateJobApplyExportByJobUuid.loading;
export const selectApplicantsError = (state) => state.employerCandidateJobApplyExportByJobUuid.error;
export const selectCurrentJobUuid = (state) => state.employerCandidateJobApplyExportByJobUuid.currentJobUuid;

export const { resetState, clearError } = employerCandidateJobApplyExportByJobUuidSlice.actions;
export default employerCandidateJobApplyExportByJobUuidSlice.reducer;